import React from "react";
import { ShieldAlert } from "lucide-react";
import { TID } from "../constants/catalog";

export default function SafetyBanner() {
  return (
    <div
      data-testid={TID.chat.banner}
      className="sticky top-14 md:top-16 z-40 bg-[#ff9500]/12 border-b border-[#ff9500]/30 text-[#9a4e00] px-4 py-2.5 text-[13px] font-medium flex items-start md:items-center gap-2 backdrop-blur-md"
    >
      <ShieldAlert className="w-4 h-4 flex-shrink-0 mt-0.5 md:mt-0" strokeWidth={1.8} />
      <span className="leading-snug">
        Caution: Before any transaction or meeting, verify the other person&rsquo;s identity and meet
        at a proper public place. PartByPart is not liable for fraud or illegal activity.
      </span>
    </div>
  );
}
